import isEmpty from "./helpers/isEmpty";

/**
 * Align industry cards inner services buttons if details in one card is longer 
 * 
 * @param {string} industriesContainerClass - selector for industries container
 * @param {string} industriesDetailsClass - selector for industries details box
 * @param {string} servicesClass - selector for industries services box
 */
const alignIndustriesCards = (
  industriesContainerClass,
  industriesDetailsClass,
  servicesClass
) => {
  const container = document.querySelector(industriesContainerClass);
  if (!container) {
    return;
  }
  const details = container.querySelectorAll(industriesDetailsClass);

  if (!details || isEmpty(details)) {
    return;
  }

  let max = 0;
  details.forEach((element) => {
    const rect = element.getBoundingClientRect();
    max = rect.height > max ? rect.height : max;
  });

  details.forEach((element) => {
    const rect = element.getBoundingClientRect();
    const serviceBox = element.parentElement
      ? element.parentElement.querySelector(servicesClass)
      : null;
    if (!serviceBox) {
      return;
    }
    const offset = max - rect.height;
    serviceBox.style.setProperty("--align-offset", `${offset}px`);
  });
};

alignIndustriesCards(
  ".industries__container",
  ".industrie__details",
  ".services"
);

window.addEventListener("resize", () =>
  alignIndustriesCards(
    ".industries__container",
    ".industrie__details",
    ".services"
  )
);

export default alignIndustriesCards;
